export default __webpack_public_path__ + "static/media/1.b2145ab6.png";